export default __webpack_public_path__ + "maps-examples-camera-animators-thumbnail-960-b59fc9a2eee8bd78892c734997c3b9fe.png";